import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5ca9433c&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca9433c')) {
      api.createRecord('5ca9433c', component.options)
    } else {
      api.reload('5ca9433c', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=5ca9433c&", function () {
      api.rerender('5ca9433c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/Dashboard.vue"
export default component.exports